import { createContext } from "react";
import { FILE_VIEW_PREFERENCE_KEYS } from "~served/configs";

export interface State {
	fileViewPreference: FILE_VIEW_PREFERENCE_KEYS;
	handleChangeViewPreference: any;
}

export const initialState: State = {
	fileViewPreference: FILE_VIEW_PREFERENCE_KEYS.KANBAN_VIEW,
	handleChangeViewPreference: null,
};

export type ViewPreferenceContext = State;

export const ViewPreferenceContext =
	createContext<ViewPreferenceContext>(initialState);
